import styled from "styled-components";

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  gap: 16px;

  .ant-checkbox-checked::after {
    color: ${props => props.theme.colors.primary};
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.primary};
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    border-color: ${props => props.theme.colors.primary};
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner {
    border-color: ${props => props.theme.colors.primary};
  }

  .ant-checkbox-checked:after { border: none !important }

`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 32px;
  align-items: center;

  @media screen and (min-width: 960px) and (max-width: 1260px){ 
    gap: 4px;
  }

  >span {
    margin: 0;
    width: 100%;
    margin-right: auto;
  }
`;

export const RowGrid = styled.div`
  display: grid;
  grid-template-columns: repeat( auto-fit, minmax(100px, 1fr) );
  align-items: end;
  gap: 64px;
  width: 100%;

  ${props => props.theme.mediaQuerie.maxWidth.md}{
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  width: 100%;
  height: 100%;
  gap: 32px;

  max-height: 74vh;
  overflow-y: scroll;

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    gap: 16px;
    max-height: fit-content;
  }
`;

export const ListEvents = styled.div`
  max-height: 60vh;
  overflow-y: scroll;
  width: 100%;
  border-radius: 8px;
  background-color: ${props => props.theme.colors.inputBackground};
  padding: 16px;
  min-height: 170px;
  gap: 16px;
  display: flex;
  flex-direction: column;

  ${props => props.theme.mediaQuerie.maxWidth.sm}{
    max-height: fit-content;
  }
`;

export const ListDays = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  flex-wrap: wrap;
  width: 100%;
  gap: 16px;
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 16px;

  ${props => props.theme.mediaQuerie.maxWidth.sm} {
    justify-content: space-between;
    width: 100%;
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  gap: 16px;
`;

export const NewDayContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px;
  gap: 16px;
  background-color: ${props => props.theme.colors.background};
  border-radius: 8px;
  width: 100%;

  ${props => props.theme.mediaQuerie.maxWidth.sm} {
    background-color: ${props => props.theme.colors.inputBackground};
  }
`;

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;

    ${props => props.theme.mediaQuerie.maxWidth.sm}{
      background-color: ${props => props.theme.colors.inputBackground};
      padding: 16px;  
      border-radius: 8px;
    }
  
`;